module.exports = __webpack_public_path__ + "img/ic-delete.833e11e6.svg";